module.exports = __webpack_public_path__ + "img/11.bd61a35e.jpg";